import { ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

export interface SocialLinksProps {
  children: ReactNode;
  className?: string;
}

export const SocialLinks = ({ children, className }: SocialLinksProps) => {
  return (
    <div
      className={twMerge(
        `flex w-full flex-row flex-wrap justify-between gap-1.5 border-b-2 border-secondary-grey-01 py-8
        lg:justify-start lg:gap-8 lg:border-b-0 lg:pt-8`,
        className,
      )}
    >
      {children}
    </div>
  );
};
